import { useMutation } from "react-query";
import { DataParceiroForm } from "../typings";
import http from "infra/http";

function useSaveParceiro(id: string | null) {
  return useMutation(
    `/v1/parceiro/${id ? id : ""}`,
    async (data: DataParceiroForm) => {
      
      const result = await http[id ? "put" : "post"]<{ id: string }>(
        `/v1/parceiro/${id ? id : ""}`,
        data
      );

      
      return result.data;
    },
    { retry: false }
  );
}

export default useSaveParceiro;
